import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "time-o",
  "use": "time-o-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"time-o\"><title>资源 1</title><path d=\"M3.51 20.49a12 12 0 1 1 17 0 12 12 0 0 1-17 0zM8 2.5a10.33 10.33 0 1 0 11.3 2.21A10.31 10.31 0 0 0 8 2.5zm4 11.84a1.85 1.85 0 0 1-1.86-1.85V6.27a.93.93 0 0 1 1.86 0v6.21h4.8a.94.94 0 0 1 1 .9.92.92 0 0 1-.9 1H12z\" data-name=\"图层 2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/time-o.svg
// module id = NEIh
// module chunks = 6